import React from 'react';
import './Headersocial.css';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'; // Import de l'icône de flèche

function Headersocial() {
  return (
    
      <div className='main14'>
        
            
        <div className="boutton-container14">
            <div className='butTsh'>
            <button className="boutton14">ACCUEIL<ArrowForwardIcon className="arrow-icon" />SERVICE SOCIAL</button>
         <h1>SERVICE SOCIAL</h1> 
        </div>
        </div>
    </div>
   
  );
}

export default Headersocial;
